import type { IconSvgObject } from './types';

const Coordinate01Icon: IconSvgObject = [
  ["path", { d: "M22 17H2M22 17L19.5806 14.5M22 17L19.5806 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 22V2M7 2L9.5 4.5M7 2L4.5 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Coordinate01Icon;
